/*
 * Copyright (c) 2020. American Express Company
 */

import _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import FormatService from '../../services/format.service';

// components
import BwSlider from '../bw-slider/BwSlider';
import GoalDrawer from './GoalDrawer';
import LiteralsService from '../../services/literals/LiteralsService';
import Output from '../atomic/molecules/output/Output';

// icons and styles
import { ReactComponent as AdjustExpensesIcon } from 'src/bw/goal/adjust-expenses.svg';

export default class AdjustExpensesDrawer extends Component<
    any,
    {
        error: string;
    }
> {
    public override state = {
        error: null as string
    };

    /// ////////////////
    // Onced Methods //
    /// ////////////////
    private readonly handleDeleteOnce: () => void = _.once(async () => {
        await this.props.handleDeleteCard(this.props.drawerProps.card);
        this.props.handleBack();
    });

    private readonly handleUpdateOnce: () => void = _.once(() => {
        void this.handleUpdate();
        this.props.handleBack();
    });

    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;

        const dateStr = FormatService.formatYearMonthDate(drawerProps.card.startDate);
        const currentTotal: number = Math.round(drawerProps.card.monthlyExpenses[dateStr] / 100) * 100;
        const expenseChange: number = _.get(drawerProps, 'card.attributes.expenseChange', 0);

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.handleDeleteOnce}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={<AdjustExpensesIcon />}
                introContent={LiteralsService.getLiteral('AdjustExpensesDrawer.intro')}
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                hasEndDate
                bottomButtonUpdate={this.handleUpdateOnce}
            >
                <BwSlider
                    key="slider"
                    id="slider"
                    label="Increase or decrease your monthly expenses"
                    value={expenseChange}
                    formattedValue={FormatService.formatCompactMoney(expenseChange)}
                    step={100}
                    min={-currentTotal}
                    max={currentTotal}
                    onChange={(value: any) =>
                        this.props.handleChangeCardAttribute(this.props.drawerProps.card, value, 'expenseChange')
                    }
                    inputToggleText="Add a precise amount"
                />

                <Output
                    title="Your adjusted monthly expenses are"
                    main={FormatService.format(currentTotal + expenseChange)}
                    subtext={expenseChange ? `Was ${FormatService.format(currentTotal)}` : null}
                />
            </GoalDrawer>
        );
    }

    private async handleUpdate(): Promise<void> {
        const drawerProps = this.props.drawerProps;

        if (drawerProps.card.endDate.isBefore(drawerProps.card.startDate)) {
            this.setState({
                error: 'Error,  end date must be after start date'
            });
            return;
        }

        await this.props.handleUpdateCard();
        this.props.handleBack();
    }
}
